import React, { useEffect } from 'react'
import Modal from 'react-bootstrap/Modal';
import metamask from './../../Assets/Image/MetaMask.png'
import walletConnect from './../../Assets/Image/WalletConnect.png'
import coinbase from './../../Assets/Image/coinbase.svg'
import { connectCoinbaseWallet, connectMetaMaskFunc, connectWalletConnect, getAuthUserWC, getMetamaskUser } from '../../module/action/user-task';
import { useDispatch, useSelector } from 'react-redux'
import Web3 from 'web3';
import { WalletConnectConnector } from '@web3-react/walletconnect-connector';
import { useWeb3React } from '@web3-react/core';
window.Buffer = window.Buffer || require('buffer').Buffer;
function ConnectModal({ show,
    setShow,
    handleClose,
    handleShow }) {
    const dispatch = useDispatch()

    const { active, account, error, activate, deactivate, library } = useWeb3React()
    useEffect(() => {
        console.log(library, 'library')
        dispatch(getAuthUserWC(handleClose, dispatch, library))
    }, [library])
    const connectWallet = () => {
        dispatch(connectMetaMaskFunc(handleClose))
    }

    const connectCoinBaseWalletFn = () => {
        dispatch(connectCoinbaseWallet(handleClose))
    }

    const walletconnect = new WalletConnectConnector({
        rpcUrl: `https://mainnet.infura.io/v3/27e484dcd9e3efcfd25a83a78777cdf1`,
        bridge: "https://bridge.walletconnect.org",
        qrcode: true
    })


    const connectors = {
        // injected,
        walletconnect,
        // uauth
    }

    function createConnectHandler(connectorId) {

        return async () => {

            // dispatch(connnectMetamaskUser())
            try {

                const connector = connectors[connectorId]

                // Taken from https://github.com/NoahZinsmeister/web3-react/issues/124#issuecomment-817631654  
                if (
                    connector instanceof WalletConnectConnector &&
                    connector.walletConnectProvider
                ) {
                    connector.walletConnectProvider = undefined
                }
                // setConnected(connector)  
                await activate(connector).then((res) => {
                    if (connectorId === 'walletconnect') {
                        console.log(res, 'resresres')
                        // getUser(true)

                        // navigation('/mint')
                        // dispatch(getAuthUserWC(handleClose, dispatch))
                    } else {
                        // getUser(true)

                        // getAuthUser(handleCancel, dispatch)
                    }
                })
                // 
                if (error) {
                    throw error;
                }
            } catch (error) {
                console.error(error)
            }
        }
    }


    return (
        <Modal show={show} onHide={handleClose} className="connectModal">
            <Modal.Body>
                <div className='wallets'>
                    <div className='WalletFirstRow'>
                        <div className='walletDiv' >
                            <div className='innerWalletDiv' onClick={connectWallet}>
                                <img src={metamask} />
                                <h3>MetaMask</h3>
                                <p>Connect to your MetaMask Wallet</p>
                            </div>
                        </div>
                        {/* <div className='walletDiv walletConn' onClick={createConnectHandler('walletconnect')}> */}
                        <div className='walletDiv walletConn' onClick={() => { dispatch(connectWalletConnect(handleClose)) }}>
                            <div className='innerWalletDiv'>
                                <img src={walletConnect} />
                                <h3>WalletConnect</h3>
                                <p>Scan with WalletConnect to connect</p>
                            </div>
                        </div>
                    </div>
                    <div className='WalletFirstRow'>
                        <div className='walletDiv' onClick={connectCoinBaseWalletFn}>
                            <div className='innerWalletDiv'>
                                <img src={coinbase} />
                                <h3>Coinbase</h3>
                                <p>Scan with Coinbase Wallet to connect</p>
                            </div>
                        </div>
                        <div className='walletDiv hideMob'></div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default ConnectModal